import { ExecTypeEnum, OrdStatusEnum, type ICustomerExecutionReport, type QuoteStatusEnum } from '../types/types';
import { includesEnumValueForSet } from './enumlikeHandlers';
import { toBigWithDefault } from './number';

const COMPLETE_ORDER_STATUSES = new Set([
  OrdStatusEnum.Canceled,
  OrdStatusEnum.Filled,
  OrdStatusEnum.Rejected,
  OrdStatusEnum.DoneForDay,
  OrdStatusEnum.PendingFix,
]);

export const isOrderComplete = (
  ordStatus: OrdStatusEnum | QuoteStatusEnum
): ordStatus is (typeof OrdStatusEnum)['Filled' | 'Canceled' | 'Rejected' | 'DoneForDay' | 'PendingFix'] =>
  includesEnumValueForSet(COMPLETE_ORDER_STATUSES, ordStatus);

/**
 * Returns true when an execution report represents a hard failure that cannot be recovered from:
 * rejected, replace/update rejected, or canceled with no fills (DEAL-2747).
 */
export const isFailedExecutionReport = (
  report: Pick<ICustomerExecutionReport, 'OrdStatus' | 'ExecType' | 'CumQty'>
): boolean =>
  report.OrdStatus === OrdStatusEnum.Rejected ||
  report.ExecType === ExecTypeEnum.ReplaceRejected ||
  report.ExecType === ExecTypeEnum.UpdateRejected ||
  (report.OrdStatus === OrdStatusEnum.Canceled && toBigWithDefault(report.CumQty, 0).eq(0));
